'use strict';

var nestedValue = require('../helpers/nestedValue');

module.exports = function whereNotBetween(key, values) {
  return this.filter(function (item) {
    return nestedValue(item, key) < values[0] || nestedValue(item, key) > values[values.length - 1];
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/whereNotBetween.js
// module id = 1745
// module chunks = 2